import { render, staticRenderFns } from "./custom-button.vue?vue&type=template&id=8570f9b6&"
import script from "./custom-button.vue?vue&type=script&lang=js&"
export * from "./custom-button.vue?vue&type=script&lang=js&"
import style0 from "./custom-button.vue?vue&type=style&index=0&id=8570f9b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports